





















































import Vue, { PropType } from 'vue';

interface Options {
  [key: string]: string;
}

export default Vue.extend({
  props: {
    isOption: Boolean as PropType<boolean>,
    limit: Number,
    value: [Array, Number, String],
    options: {
      type: Object as PropType<Options>,
      default: () => ({}),
    },
  },
  data: () => ({
    filter: '',
  }),
  computed: {
    filtered(): Options {
      const searchKey = this.filter.toLowerCase();
      return this.optionKeys
        .reduce((list, key) => {
          const value = this.options[key];
          const isFound = value.toLowerCase().includes(searchKey);
          if (isFound) {
            list[key] = value;
          }
          return list;
        }, {} as Options);
    },
    filterKeys(): string[] {
      return Object.keys(this.filtered);
    },
    noColumns(): boolean {
      return this.filterKeys.length < 10;
    },
    optionKeys(): string[] {
      return Object.keys(this.options);
    },
    showFilter(): boolean {
      return this.optionKeys.length > 10;
    },
  },
  methods: {
    focus(event: KeyboardEvent, next: boolean) {
      const target = event.target as HTMLDivElement;
      const nextElement = next
        ? target.nextElementSibling
        : target.previousElementSibling;
      if (nextElement) {
        (nextElement as HTMLDivElement).focus();
        this.preventScroll(event);
      } else if (next === false) {
        this.focusOnFilter();
      }
    },
    focusOnFilter() {
      const filterInput = this.$refs.filterInput;
      filterInput
        && (filterInput as HTMLDivElement).focus();
    },
    focusOnFirstItem(event: KeyboardEvent) {
      const [firstKey] = this.filterKeys;
      const ref = this.$refs[`option-${firstKey}`];
      if (Array.isArray(ref) && ref[0]) {
        (ref[0] as HTMLElement).focus();
        this.preventScroll(event);
      }
    },
    preventScroll({ view }: KeyboardEvent) {
      // prevent scroll
      view
        && view.event
        && view.event.preventDefault();
    },
    select(key: string) {
      if (this.isOption) {
        (this.value as string[]).includes(key)
          ? this.optionUnselect(key)
          : this.optionSelect(key);
      } else {
        // emit update and close
        this.$emit('input', key);
        this.$emit('close');
      }
    },
    selectFirstItem() {
      // select first item if filter value has been passed
      if (this.filter) {
        const [firstKey] = this.filterKeys;
        firstKey && this.select(this.options[firstKey]);
      }
    },

    // methods only for option type
    optionSelect(key: string) {
      const limit = this.limit || 1e5;
      const value = this.value as string[];
      if (limit === 1) {
        this.$emit('input', [key]);
        this.$emit('close');
      } else if (value.length < limit) {
        const selected = [...new Set(value.concat(key))];
        this.$emit('input', selected);
      }
    },
    optionUnselect(key: string) {
      const value = this.value as string[];
      const filtered = value.filter(item => item !== key);
      this.$emit('input', filtered);
    },
  },
});
